import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { routes } from './router';

let now = '';

const pageClassNames = {
  'app-router-effect': true,
  fade: false,
  'swipe-right': false,
  'swipe-left': false
};

const applyEffect = to => {
  // limpando efeitos
  pageClassNames.fade = false;
  pageClassNames['swipe-right'] = false;
  pageClassNames['swipe-left'] = false;

  const toRoute = routes.find(item => item.key === to);

  if (toRoute.effect === 'swipe') {
    const indexNow = routes.findIndex(item => item.key === now);
    const indexTo = routes.findIndex(item => item.key === to);

    if (indexTo > indexNow) {
      pageClassNames['swipe-right'] = true;
    } else if (indexTo < indexNow) {
      pageClassNames['swipe-left'] = true;
    }
  } else {
    pageClassNames[toRoute.effect] = true;
  }

  now = to;
};

const ScreenTransitionEffect = ({ children }) => {
  return <section className={classNames(pageClassNames)}>{children}</section>;
};

ScreenTransitionEffect.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export { ScreenTransitionEffect, applyEffect };
export default ScreenTransitionEffect;
